import { useQuery } from "@tanstack/react-query";
import { getProspectFeedMembers } from "@/app/actions/prospect-search/feed/action";
import {
  PROSPECT_ACTION_FILTER_ALL,
  ProspectActionFilter,
  prospectActionFilterKey,
} from "@/app/types/prospect/ProspectActionFilter";
import { ProspectListTab } from "@/app/types/prospect/ProspectListTab";
import { QueryKey } from "@/app/vars/QueryKeys";

type Options = {
  avatarId?: number;
  tab?: ProspectListTab;
  actionFilter?: ProspectActionFilter;
  enabled?: boolean;
};

export function useFetchProspectFeedMembers(options: Options) {
  const {
    avatarId,
    tab = ProspectListTab.ALL,
    actionFilter = PROSPECT_ACTION_FILTER_ALL,
    enabled = true,
  } = options;

  return useQuery({
    queryKey: [
      QueryKey.PROSPECT_FEED_MEMBERS,
      avatarId,
      tab,
      prospectActionFilterKey(actionFilter),
    ],
    queryFn: () => getProspectFeedMembers(avatarId!, tab, actionFilter),
    enabled: enabled && !!avatarId,
    staleTime: Infinity,
  });
}
